import React, { useState } from 'react'
import { TypographyTitle } from 'src/components/common/Typography/typography'
import { ContentButton, Description } from './styles'
import { SuccessStoriesLabels } from 'src/constants'
import { MapSuccess } from './mapSuccess'
import Button from 'src/components/common/Button'
import { useAnimation } from 'src/hook'
import { scaleVariantTitle } from 'src/theme/animations/swipeIn'
import { OverSection } from 'src/pages/Home/styles'
import { useTranslations } from 'src/provider/LocaleProvider'

export const SuccessStories = () => {
    const t = useTranslations()
    const { ContentSuccessStories } = SuccessStoriesLabels()
    const { control, ref } = useAnimation({ initialSpriteIdTitle: 2 })
    const [showAll, setShowAll] = useState(false)
    const maxItemsToShow = 2
    const handleShowAll = () => {
        setShowAll(true)
    }
    const handleCollapse = () => {
        setShowAll(false)
    }

    return (
        <OverSection
            paddingTop={['medium', 'medium', 'large', 'titlle']}
            paddingBottom={['medium', 'medium', 'large', 'titlle']}
            ref={ref}
        >
            <TypographyTitle
                variant={'h1'}
                fontSize={['xxxlarge', 'xxxlarge', 'xxxlarge', 'titlle']}
                fontWeight={600}
                initial="hidden"
                animate={control}
                variants={scaleVariantTitle}
            >
                {t('successStories.title')}
            </TypographyTitle>
            <Description
                variant={'h1'}
                fontSize={['xxxsmall', 'xxxsmall', 'medium', 'xxxmedium']}
                fontWeight={400}
                initial="hidden"
                animate={control}
                variants={scaleVariantTitle}
            >
                {t('successStories.tagline')}
            </Description>

            {ContentSuccessStories.slice(
                0,
                showAll ? ContentSuccessStories.length : maxItemsToShow
            ).map((item) => (
                <MapSuccess key={item.id} {...item} />
            ))}

            {!showAll && ContentSuccessStories.length > maxItemsToShow && (
                <ContentButton>
                    <Button
                        onClick={handleShowAll}
                        Content={t('cta.seeMore')}
                    />
                </ContentButton>
            )}
            {showAll && (
                <ContentButton>
                    <Button
                        onClick={handleCollapse}
                        Content={t('cta.seeLess')}
                    />
                </ContentButton>
            )}
        </OverSection>
    )
}
